import { IonContent, IonPage } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CommonHeader from "../../../CommonHeader";
import secondMedicalOpinionImg from "../../../assets/images/second-medical-opinion.png";

export default function SecondMedicalOpinionLanding() {
  const history = useHistory();
  const [isPB, setIsPB] = useState(false);

  useEffect(() => {
    const source = localStorage.getItem("app_source");
    setIsPB(source === "pb");
  }, []);

  const handleContinue = () => {
    history.replace("/navigo?currScreen=1&pageType=8");
  };

  return (
    <IonPage>
      <IonContent>
        {isPB && <CommonHeader />}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100%",
            padding: "20px",
            boxSizing: "border-box",
            backgroundColor: "#FFFFFF",
            fontFamily: "'Montserrat', sans-serif",
          }}
        >
          <p
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "18px",
              fontWeight: 700,
              color: "#12194C",
              letterSpacing: "-0.2px",
              margin: 0,
              marginBottom: "24px",
            }}
          >
            Second medical opinion
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "16px",
            }}
          >
            <img
              src={secondMedicalOpinionImg}
              alt="Second medical opinion"
              style={{
                width: "100%",
                maxWidth: "360px",
                height: "auto",
              }}
            />
          </div>

          <h2
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "22px",
              fontWeight: 700,
              lineHeight: "30px",
              letterSpacing: "-0.3px",
              color: "#1A1A1A",
              textAlign: "center",
              marginTop: "32px",
              marginBottom: "12px",
            }}
          >
            Looking for more clarity about your diagnosis or treatment plan?
          </h2>

          <p
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "15px",
              fontWeight: 400,
              lineHeight: "22px",
              color: "#6B7280",
              textAlign: "center",
              margin: 0,
            }}
          >
            Our specialists are here to listen, understand, and help with a
            trusted second opinion.
          </p>

          <div style={{ flex: 1 }} />

          <button
            onClick={handleContinue}
            style={{
              width: "100%",
              padding: "16px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "16px",
              fontWeight: 600,
              color: "#FFFFFF",
              backgroundColor: "#97144D",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              marginTop: "24px",
            }}
          >
            Continue
          </button>
        </div>
      </IonContent>
    </IonPage>
  );
}
